import React from "react";
import PropTypes from "prop-types";
import cname from "../WidgetStyles";

/**
 * Slider:
 *  - Wrapper for RangeSlider, SliderText and RangeSliderLabel
 */
export function Slider(props) {
  return <div className={cname.slider}>{props.children}</div>;
}

Slider.propTypes = {
  /**
   * Child components to be rendered inside Slider
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

Slider.defaultProps = {};
